// True when a keystroke lands in a text box that already holds text, so keys
// like Delete edit that text instead of acting on the selected bag line.
export const isEditingText = (target) => {
  const tag = target?.tagName;
  if (tag !== "INPUT" && tag !== "TEXTAREA") return false;
  return typeof target.value === "string" && target.value.length > 0;
};
